import axios from './axiosInstances/axiosInstance';

export const setBasketHandoffMethod = (basketGuid, deliveryMode) => {
  return axios.put(`baskets/${basketGuid}/deliverymode`, {
    deliverymode: deliveryMode,
  });
};
